
export default {
    props: ['banniereUrl', 'videoDeFondUrl','link','banniereUrlValidaion'],
    data() {
        return {apikey : process.env.gmapApiKey}
    },
    mounted(){
        setTimeout(() => {
            // document.getElementById("bgimgcampus").style.visibility = "hidden";
            if (this.$refs.videobackground) {
            this.$refs.videobackground.player.play()
        }
        }, 3000);
    },
}
